<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup" *ngIf="permissaoInserir">
                <div class="p-fluid p-formgrid grid flex justify-content-between">
                    <div class="col-12 sm:col-2">
                        <button
                            pButton
                            pRipple
                            routerLink="/apps/item-servico/inserir"
                            label="Novo"
                            icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"
                        ></button>
                    </div>
                    <div class="col-12 sm:col-6 flex justify-content-end">
                        <button
                            pButton
                            pRipple
                            tooltipPosition="left"
                            pTooltip="Gerar relatório de preços"
                            label="Tabela Preços"
                            [icon]="
                                loadingRelatorioPreco ? 'pi pi-spin pi-spinner' : 'pi pi-file-pdf'
                            "
                            class="p-button-outlined sm:w-auto mr-2"
                            (click)="obterRelatorioPreco()"
                            [disabled]="loadingRelatorioPreco || !situcaoSelecionada"
                        ></button>
                        <button
                            pButton
                            pRipple
                            tooltipPosition="left"
                            pTooltip="Gerar relatório de precificação"
                            label="Precificação"
                            [icon]="
                                loadingRelatorioPrecificacao
                                    ? 'pi pi-spin pi-spinner'
                                    : 'pi pi-file-pdf'
                            "
                            class="p-button-outlined sm:w-auto"
                            (click)="obterRelatorioPrecificacao()"
                            [disabled]="loadingRelatorioPrecificacao || !situcaoSelecionada"
                        ></button>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="itensServicos"
                dataKey="id"
                [rows]="itensServicosPaginados ? itensServicosPaginados.size : 0"
                (onPage)="onPageChange($event)"
                [loading]="loadingTable"
                [rowHover]="true"
                [paginator]="true"
                [lazy]="true"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
                [showCurrentPageReport]="true"
                [totalRecords]="itensServicosPaginados ? itensServicosPaginados.totalElements : 0"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <p-dropdown
                            class="p-fluid sm:mr-2"
                            [options]="situacoesStatus"
                            optionLabel="label"
                            optionValue="value"
                            emptyFilterMessage="Nenhum registro"
                            name="situacao"
                            ngModel
                            #situacao="ngModel"
                            [(ngModel)]="situcaoSelecionada"
                            (onChange)="carregarItensServicos(0)"
                        ></p-dropdown>

                        <div class="p-fluid w-full sm:w-auto mt-2 sm:mt-0">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar($event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar()"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="descricao">
                            Descrição
                            <p-sortIcon field="descricao"></p-sortIcon>
                        </th>
                        <th pSortableColumn="codigo">
                            Código
                            <p-sortIcon field="codigo"></p-sortIcon>
                        </th>
                        <th pSortableColumn="grupo">
                            Grupo
                            <p-sortIcon field="grupo"></p-sortIcon>
                        </th>
                        <th pSortableColumn="status">
                            Status
                            <p-sortIcon field="status"></p-sortIcon>
                        </th>
                        <th>
                            <div style="text-align: center">Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.descricao }}
                        </td>
                        <td>
                            {{ item.codigo }}
                        </td>
                        <td>{{ item.subgrupo.grupo.descricao }} - {{ item.subgrupo.descricao }}</td>
                        <td>
                            <span class="product-badge status-instock" *ngIf="item.ativo">
                                ATIVO
                            </span>
                            <span class="product-badge status-outofstock" *ngIf="!item.ativo">
                                INATIVO
                            </span>
                        </td>

                        <td style="text-align: center">
                            <div>
                                <button
                                    *ngIf="permissaoDetalhar"
                                    pButton
                                    pRipple
                                    pTooltip="Detalhar"
                                    icon="pi pi-eye"
                                    (click)="
                                        redirecionarPagina('/apps/item-servico/detalhar/' + item.id)
                                    "
                                    class="p-button-info mr-2 mb-2"
                                ></button>
                                <button
                                    *ngIf="permissaoEditar"
                                    pButton
                                    pRipple
                                    pTooltip="Editar"
                                    icon="pi pi-pencil"
                                    (click)="
                                        redirecionarPagina('/apps/item-servico/editar/' + item.id)
                                    "
                                    class="p-button-success mr-2 mb-2"
                                ></button>
                                <button
                                    *ngIf="permissaoExcluir"
                                    pButton
                                    pRipple
                                    pTooltip="Excluir"
                                    icon="pi pi-trash"
                                    class="p-button-danger mr-2 mb-2 sm"
                                    (click)="excluirItemServico(item.id)"
                                ></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando grupos. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
